// Step 2 - Starting the 2FA registration process

export default function Start2FARegistrationMessage({ onNext, onPrevious, registrationState }) {
    

    
    return <div className="flex flex-col gap-3">
        <h1 className="font-bold">Download google authenticator</h1>

        <div className="flex flex-row justify-center">
            <img src="https://portal.zorgconnect.u-staat-centraal.nl/img/google-authenticator.webp" />

        </div>
        <p>
            Download nu in de app store van uw telefoon de applicatie genaamd ‘google authenticator’ en volg daarin de 
            stappen (zorg ervoor dat het icoontje overeenkomt met de bovenstaande plaatje), klik op volgende 
            als u dit gedaan heeft.
        </p>
        <div className="flex flex-row gap-3 w-full">
         
            <button className="flex-1 px-3 py-2 bg-green-500 text-white" onClick={() => onNext()}>Volgende</button>
        </div>
    </div>
}
